module.exports = __webpack_public_path__ + "img/live.ea5375e3.svg";